export default __webpack_public_path__ + "static/media/009-flip flops.1b756884.svg";